import { NavLink } from 'react-router'
import { cn } from '@/lib/utils'
import { getNavigationIcon, getNavigationItems } from '@/lib/navigation'
import { useAuth } from '@/providers/auth-provider'

interface AdminSidebarNavProps {
  collapsed: boolean
}

export function AdminSidebarNav({ collapsed }: AdminSidebarNavProps) {
  const { user } = useAuth()
  const navItems = getNavigationItems('admin', user)

  return (
    <nav className="flex flex-col gap-3 p-3">
      {!collapsed && (
        <div className="px-2">
          <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-white/45">
            Workspace
          </p>
        </div>
      )}
      {navItems.map(({ icon, label, href }) => {
        const Icon = getNavigationIcon(icon)
        return (
        <NavLink
          key={href}
          to={href}
          end={href === '/admin'}
          className={({ isActive }) =>
            cn(
              'group flex items-center gap-3 rounded-2xl border border-transparent px-3 py-3 text-sm transition-all',
              'text-white/84 hover:border-white/8 hover:bg-white/8 hover:text-white',
              isActive &&
                'border-white/12 bg-white/12 text-white font-medium shadow-lg shadow-black/20',
              collapsed && 'justify-center px-2'
            )
          }
          title={collapsed ? label : undefined}
        >
          <Icon className="h-4 w-4 shrink-0 transition-transform group-hover:scale-105" />
          {!collapsed && <span>{label}</span>}
        </NavLink>
        )
      })}
    </nav>
  )
}
